import {
  Body,
  Icon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@growtherapy/sprout-ui";
import { RejoinModalViewModel } from "./types";
import { faWifiSlash } from "@fortawesome/pro-duotone-svg-icons";
import { useTranslate } from "@growtherapy/i18n";

export function RejoinModal({
  isOpen,
  onJoin: handleJoin,
  isLoading,
}: RejoinModalViewModel) {
  const t = useTranslate();
  return (
    <Modal className="sm:mt-[10%]" isOpen={isOpen}>
      <ModalHeader>
        <Icon className="mr-2" icon={faWifiSlash} />
        {t("telehealth-core:rejoin.connectionLost")}
      </ModalHeader>
      <ModalBody>
        <Body.Default>
          {t("telehealth-core:rejoin.yourConnectionWasInterrupted")}
        </Body.Default>
      </ModalBody>
      <ModalFooter
        actions={[
          {
            key: "rejoin-session",
            "aria-label": isLoading
              ? t("telehealth-core:rejoin.reconnecting")
              : t("telehealth-core:rejoin.reconnect"),
            use: "primary",
            loading: isLoading,
            onClick: handleJoin,
            actionContent: t("telehealth-core:rejoin.rejoinSession"),
          },
        ]}
      />
    </Modal>
  );
}
